import { postAuthorName, postLinkDomain, postLinkUrl, postMediaGrid } from '../../../../lib/social-post-look-parts';
import { X_CAPTION_LIMIT, X_RENDITIONS, xGridRendition, xHandle } from '../../../../lib/x-post-preview';
import {
  PostAvatar,
  PostCaption,
  PostGrid,
  PostSingleMedia,
  PostTiming,
  useMediaLabel,
  type SocialPostLookProps,
} from './SocialPostLookParts';
import styles from './XPostPreview.module.css';

export function XPostPreview({ card, onOpenMedia, onToggleCaption, onOpenLink }: SocialPostLookProps) {
  const label = useMediaLabel(card);
  const grid = postMediaGrid(card);
  const linkUrl = grid.kind === 'none' ? postLinkUrl(card.link) : undefined;
  const handle = xHandle(card);
  return (
    <div className={styles.post}>
      <PostAvatar card={card} name={postAuthorName(card)} size={24} logoSize={14} />
      <div className={styles.body}>
        <header className={styles.header}>
          <p className={styles.line}>
            <span className={styles.name} data-testid="x-name">
              <bdi>{postAuthorName(card)}</bdi>
            </span>
            {handle && (
              <>
                {' '}
                <span className={styles.handle} data-testid="x-handle">
                  {handle}
                </span>
                <span aria-hidden="true">{' · '}</span>
              </>
            )}
            <span data-testid="x-when">
              <PostTiming card={card} />
            </span>
          </p>
        </header>
        {card.caption && (
          <PostCaption
            caption={card.caption}
            className={styles.caption}
            testId="x-caption"
            cut={{ limit: X_CAPTION_LIMIT }}
            onToggle={onToggleCaption}
          />
        )}
        {grid.kind === 'single' && (
          <PostSingleMedia
            key={grid.tile.url}
            media={grid.tile}
            label={label(grid.tile, 0)}
            rendition={X_RENDITIONS.single}
            className={`${styles.media} ${styles.single}`}
            testId="x-media"
            onOpen={() => onOpenMedia(grid.tile, 0)}
          />
        )}
        {grid.kind === 'grid' && (
          <PostGrid grid={grid} label={label} rendition={xGridRendition} className={styles.media} testId="x-media" onOpen={onOpenMedia} />
        )}
        {linkUrl && (
          <a
            className={styles.linkCard}
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
            onClick={onOpenLink}
            data-testid="x-link-card"
          >
            <span className={styles.domain} data-testid="x-link-domain">
              {postLinkDomain(linkUrl, { keepWww: true })}
            </span>
            <span className={styles.linkTitle}>{linkUrl}</span>
          </a>
        )}
      </div>
    </div>
  );
}
